<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--캠페인정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001178') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">{{ getMessage_('QWCC001024') }}</th>
							<!--캠페인No-->
							<td class="col-1">
								<el-input
									v-model="cmpnNo"
									maxlength="20"
									:readonly="roApcnPopUp.readOnlyAuth1"
									@keyup.native.delete="ondeleteCmpnNo()"
									@change="ondeleteCmpnNo"
								/>
								<i class="icon-sf-search search-icon2" @click="() => onCmpnMstPopup()"></i>
							</td>
							<!--캠페인명-->
							<th class="col-1">{{ getMessage_('QWCC001007') }}</th>
							<td class="col-1">
								<el-input v-model="cmpnNm" readonly />
							</td>
							<!--op코드-->
							<th class="col-1">{{ getMessage_('QWCC001096') }}</th>

							<td class="col-1">
								<el-input v-model="opCd" maxlength="20" readonly />
							</td>

							<!--op코드명-->
							<th class="col-1">{{ getMessage_('QWCC001807') }}</th>
							<td class="col-1"><el-input v-model="opNm" maxlength="20" readonly /></td>
							<!--협력사-->
							<th class="col-1">{{ getMessage_('QWCC001341') }}</th>
							<td class="col-1"><el-input v-model="camCpnyMm" maxlength="20" readonly /></td>
						</tr>
						<tr>
							<th class="col-1">{{ getMessage_('QWCC001924') }}</th>
							<!--실납품사-->
							<td class="col-1"><el-input v-model="dlvgNm" maxlength="20" readonly /></td>

							<th class="col-1">{{ getMessage_('QWCC001025') }}</th>
							<!--캠페인 시작일-->
							<td class="col-1"><el-input v-model="cmpnStrDd" readonly /></td>

							<th class="col-1">{{ getMessage_('QWCC001026') }}</th>
							<!--캠페인 종료일-->
							<td class="col-1"><el-input v-model="cmpnEndDd" readonly /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			cmpnNo: '', //캠페인코드
			cmpnNm: '', //캠페인명
			opCd: '', //오피코드
			opNm: '', //오피코드명
			camCpnyMm: '', //캠페인 협력사
			dlvgNm: '', //캠페인 실납품사
			cmpnStrDd: '', //캠페인 시작일자
			cmpnEndDd: '' //캠페인 종료일자
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setProcessInfo() {
			this.cmpnNo = this.roApcnPopUp.cmpnNo; //캠페인코드
			this.cmpnNm = this.roApcnPopUp.cmpnNm; //캠페인명
			this.opCd = this.roApcnPopUp.opCd; //오피코드
			this.opNm = this.roApcnPopUp.opNm; //오피코드
			this.camCpnyMm = this.roApcnPopUp.camCpnyMm; //협력사명
			this.dlvgNm = this.roApcnPopUp.dlvgNm; //협력사명
			this.cmpnStrDd = this.roApcnPopUp.cmpnStrDd; //캠페인시작일자.
			this.cmpnEndDd = this.roApcnPopUp.cmpnEndDd; //캠페인종료일자.
		},

		/*******************************************얼그레이아이스티 ******************************/

		onCmpnMstPopup() {
			//캠페인 목록 팝업
			if (!this.roApcnPopUp.readOnlyAuth1) {
				this.setState_({ key: 'isDelPwaCompInitFlag', value: false });
				this.setState_({ key: 'isDelCamPaignCompInitFlag', value: false });
				this.setState_({ key: 'isDelPwaCompInitFlag2', value: false });
				let cmpnNo = this.cmpnNo;

				this.$emit('OpenCmpnMstPopup', cmpnNo);
			}
		},
		//캠페인 선택 캠페인정보 세팅
		seletedCmpnNo() {
			if (!this.roApcnPopUp.readOnlyAuth1) {
				this.cmpnNo = this.currentCmpnCd;
				this.cmpnNm = this.currentCmpnNm;
				this.opCd = this.currentOpCode;
				this.opNm = this.currentOpNm;
				this.camCpnyMm = this.currentCpnyNm;
				this.dlvgNm = this.currentdlvgNm;

				this.cmpnStrDd = this.currentCmpnStdt; //캠페인시작일자.
				this.cmpnEndDd = this.currentCmpnEndDt; //캠페인종료일자.

				//차량정보를 공백으로 셋팅한다.
				//this.setStateRoApcnPopup_({ key: 'pmcNo', value: '' }); //PMC번호
				//this.setStateRoApcnPopup_({ key: 'vehlCd', value: '' }); //차종코드
				//this.setStateRoApcnPopup_({ key: 'carTypeNm', value: '' }); //차종유형
				// this.setStateRoApcnPopup_({ key: 'custNm', value: '' }); //판매사
				// this.setStateRoApcnPopup_({ key: 'saleRegnNm', value: '' }); //판매지역
				// this.setStateRoApcnPopup_({ key: 'jvSaleDd', value: '' }); //HTWO판매일
				// this.setStateRoApcnPopup_({ key: 'milg', value: '' }); //보증주행거리
				// this.setStateRoApcnPopup_({ key: 'usePrdPo', value: '' }); //보증사용기간
				// this.setStateRoApcnPopup_({ key: 'flclSpcNm', value: '' }); //연료전지사양
				// this.setStateRoApcnPopup_({ key: 'oemSaleDd', value: '' }); //고객판매일

				//PWA 정보
				this.setStateRoApcnPopup_({ key: 'pwaNo', value: '' }); //PWA번호
				this.setStateRoApcnPopup_({ key: 'prcsStepNm', value: '' }); //처리단계명
				this.setStateRoApcnPopup_({ key: 'prcStep', value: '' }); //처리단계
				this.setStateRoApcnPopup_({ key: 'aplcDd', value: '' }); //신청일
				this.setStateRoApcnPopup_({ key: 'dcsnDd', value: '' }); //확정일

				//this.setState_({ key: 'isDelPwaCompInitFlag', value: true });
				this.setState_({ key: 'isDelCamPaignCompInitFlag', value: true });
				//각 컴포넌트 disable풀기
				this.setStateRoApcnPopup_({ key: 'readOnlyAuth', value: false });
			}
		},
		ondeleteCmpnNo() {
			this.cmpnNo = '';
			this.cmpnNm = '';
			this.opCd = '';
			this.opNm = '';
			this.camCpnyMm = '';
			this.dlvgNm = '';

			this.cmpnStrDd = ''; //캠페인시작일자.
			this.cmpnEndDd = ''; //캠페인종료일자.

			this.setState_({ key: 'currentCmpnCd', value: '' });
			this.setState_({ key: 'currentCmpnNm', value: '' });
			this.setState_({ key: 'currentOpCode', value: '' });
			this.setState_({ key: 'currentOpNm', value: '' });
			this.setState_({ key: 'roApcnSwapPartsList', value: [] });
			this.setState_({ key: 'cmpnMstPartSelected', value: [] });
			this.setStateRoApcnPopup_({ key: 'ctype', value: '' });
			this.setStateRoApcnPopup_({ key: 'ceqType', value: '' });

			this.$emit('deletePartList');

			this.setState_({ key: 'isDelCamPaignCompInitFlag', value: true });

			this.setState_({ key: 'isDelPwaCompInitFlag2', value: true });

			//각 컴포넌트 disable풀기
			this.setStateRoApcnPopup_({ key: 'readOnlyAuth', value: false });
		}
	},
	/*******************************************얼그레이아이스티 ******************************/

	async created() {
		//스토어에서 값을 가져와서 셋팅한다.

		this.cmpnNo = this.roApcnPopUp.cmpnNo; //캠페인코드
		this.cmpnNm = this.roApcnPopUp.cmpnNm; //캠페인명
		this.opCd = this.roApcnPopUp.opCd; //오피코드
		this.opNm = this.roApcnPopUp.opNm; //오피코드
		this.camCpnyMm = this.roApcnPopUp.camCpnyMm; //캠페인 협력사
		this.dlvgNm = this.roApcnPopUp.dlvgNm; //캠페인 실납품사.

		this.cmpnStrDd = this.roApcnPopUp.cmpnStrDd; //캠페인시작일자.
		this.cmpnEndDd = this.roApcnPopUp.cmpnEndDd; //캠페인종료일자.
	},
	watch: {
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateApcnSave_({ key: 'cmpnNo', value: convertNvl(this.cmpnNo, '') }); //캠페인코드
				this.setStateApcnSave_({ key: 'cmpnNm', value: convertNvl(this.cmpnNm, '') }); //캠페인명
				this.setStateApcnSave_({ key: 'opCd', value: convertNvl(this.opCd, '') }); //오피코드
			}
		}
	}
};
</script>
<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
